window.addEventListener("HulkEvents", () => {

  const interval = setInterval(() => {
    const optionSet = document.querySelector(".hulkapps_option_set");
    if (optionSet) {
      clearInterval(interval);

      const option = optionSet.querySelector(".hulk-custom");

      const newImg = document.createElement("img");
      newImg.src = "";
      newImg.alt = "Selected greeting card";
      newImg.className = "hulkapps-custom-img";

      option.appendChild(newImg);

      // Step 1: Get all relevant <li> elements
      const listItems = option.querySelectorAll(
        "li:not(.init)"
      );


      // Step 2: Extract values from data attributes
      const values = Array.from(listItems)
        .map((li) => li.dataset["value"])
        .filter(Boolean); // Remove any undefined/null


      // Step 3: Create the <select> element
      const select = document.createElement("select");


      // Step 4: Populate the <select> with <option> elements
      values.forEach((val) => {
        const option = document.createElement("option");
        option.value = val;
        option.textContent = val;
        select.appendChild(option);
      });

      // Step 5: Insert the <select> inside a certain element
      const container = document.querySelector(
        ".hulk-custom .hulkapps_option_value"
      );
      if (container) {
        container.appendChild(select);
      }

      select.addEventListener("change", (event) => {
        let selectedValue = event.target.value;

        const elementToClick = document.querySelector(
          `.hulk-custom li[data-value='${selectedValue}']`
        );

        if (elementToClick) {
          elementToClick.click();
        }
        

        // adjust image
        let imgSrc = '';
        if (selectedValue != '') {
          imgSrc = document.querySelector(`.hulk-custom li[value='${selectedValue}'] img`)?.src ?? '';
        }
        newImg.src = imgSrc;
      });


      // observe for conditional change
      const observer = new MutationObserver(() => {
        const isHidden = option.classList.contains('conditional');

        if (isHidden) {
          // reset element if hidden
          const selectElement = option.querySelector('select');
          if (selectElement) {
            selectElement.selectedIndex = 0;
          }
          // clear image
          newImg.src = "";
        }
      });

      observer.observe(option, {
        attributes: true,
        attributeFilter: ['class'],
      });

      const modal = document.createElement("div");
      modal.className = "image-modal-overlay";

      const modalContent = document.createElement("div");
      modalContent.className = "image-modal-content";

      const closeBtn = document.createElement("div");
      closeBtn.className = "image-modal-close";
      closeBtn.textContent = "✕";

      modalContent.appendChild(closeBtn);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          modal.classList.remove("active");
          modalContent.querySelector("img")?.remove();
        }
      });

      closeBtn.addEventListener("click", () => {
        modal.classList.remove("active");
        modalContent.querySelector("img")?.remove();
      });

      document.querySelectorAll(".hulkapps-custom-img").forEach((img) => {
        img.style.cursor = "pointer";
        img.addEventListener("click", () => {
          const modalImg = document.createElement("img");
          modalImg.src = img.src;
          modalContent.appendChild(modalImg);
          modal.classList.add("active");
        });
      });

      select.dispatchEvent(new Event('change'));
    }
  }, 100);
});
